<template>
  <div>
    <v-client-table
      :data="lignes"
      :columns="columns"
      :options="options">
      <template #libelle="{ row }">
        {{ row.libelle }}
      </template>
      <template #produit="{ row }">
        <router-link-blank
          :to="{ name: 'c.bodac.catalogue-impressionAffiche', params: { id: row.produitId }}"
          :message="row.produit.libelle">
        </router-link-blank>
      </template>
      <template #lieuDeLivraison="{ row }">
        <router-link-blank
          v-if="row.lieuDeLivraisonId"
          :to="{ name: 'c.achat.fournisseurs', params: { id: row.lieuDeLivraisonId }}"
          :message="row.lieuDeLivraison.nomCommercial">
        </router-link-blank>
      </template>
      <template #quantite="{ row }">
        <div class="is-pulled-right">
          {{ row.quantite }}
        </div>
      </template>
      <template #quantiteRapproche="{ row }">
        <div class="is-pulled-right">
          {{ getQuantiteRapproche(row) }}
        </div>
      </template>
      <template #quantiteResteARapprocher="{ row }">
        <div class="is-pulled-right">
          {{ row.quantiteResteARapprocher }}
        </div>
      </template>
      <template #etatRapprochement="{ row }">
        {{ getEtatLibelle(row.etatRapprochement) }}
      </template>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';
import { LIGNES_COMMANDES_ETAT_RAPPROCHEMENT } from '@/configuration/achat/bonReception/rapprochementConfig';

export default {
  name: 'RapprochementsLigneChildRow',
  components: {
    RouterLinkBlank,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      func: { formatDate },
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'libelle' },
        { name: 'produit' },
        { name: 'lieuDeLivraison' },
        { name: 'quantite' },
        { name: 'quantiteRapproche' },
        { name: 'quantiteResteARapprocher' },
        { name: 'etatRapprochement' },
      ];
    },
    lignes() {
      return this.data.lignesCommande.map(ligne => {
        return ligne.lieuxLivraisons.map(ligneLieux => {
          return {
            ...ligneLieux,
            libelle: ligne.libelle,
            produit: ligne.produit,
            produitId: ligne.produitId,
          };
        });
      }).flat(2);
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, val) => {
        acc[val.name] = this.$t(`listeSuiviAchats.tableLigneCommande.${val.name}`) || '';
        return acc;
      }, {});
      return {
        texts,
        headings,
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPage: tableConfig.RESULTS_PER_PAGE,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        sortable: [],
        columnsClasses: {
          libelle: 'min250px',
          quantite: 'colonneSelected',
          quantiteARapprocher: 'colonneSelected',
          quantiteResteARapprocher: 'colonneWidth250px',
          etatRapprochement: 'colonneWith180',
        },
      };
    },
  },
  methods: {
    getQuantiteRapproche(ligne) {
      return ligne.quantite - ligne.quantiteResteARapprocher;
    },
    getEtatLibelle(etat) {
      const find = LIGNES_COMMANDES_ETAT_RAPPROCHEMENT.find((el) => el.code === etat);
      return find ? this.$t(find.libelle) : '';
    },
  },
};
</script>
